import { defineStore } from 'pinia'
import { cloneDeep } from 'lodash'
import { queryFolderCollaborators, queryModulePermissions } from '@/service/api/database'
import runningEnvironment from '@/utils/runningEnvironment.js'
import { databaseAnalyzePrompt } from '@/service/api/aiDam'
import router from '@/router'
import { ExclamationCircleFilled } from '@ant-design/icons-vue'
import { h } from 'vue'
import { Modal as AModal, message } from 'ant-design-vue'
// import { userAppPermission } from '@/service/api/app'
import eventsBus from '@/utils/eventsBus'
import { localCache } from '@/utils/cache'
export const knowStore = defineStore('knowStore', {
  state: () => {
    return {
      // 团队/个人知识库
      knowType: '',
      passwordVal: '',
      surplus: 0,
      getProblem: false,
      // 当前文件id
      fileId: '',
      allCaseList: [],
      checkedNodes: [],
      checkedKeys: [],
      selectClassify: [],
      permissionList: [],
      selectList: ['0'],
      uploadFile: [],
      fileLength: 0,
      caseLength: 0,
      newFolderVisible: false,
      newFolderData: null,
      sortFolderVisible: false,
      sortFolderData: null,
      copyFolderVisible: false,
      copyFolderData: null,
      moveFolderVisible: false,
      moveFolderData: null,
      deleteFolderVisible: false,
      deleteFolderData: null,
      shareFolderVisible: false,
      shareFolderData: null,
      saveToDatabaseVisible: false,
      saveToDatabaseData: null,
      teamWorkerModalVisible: false,
      teamWorkerModalData: null
    }
  },
  getters: {},
  //可以操作异步 和 同步提交state
  actions: {
    //生成同款
    async generateSame(value) {
      // const hasPre = await userAppPermission({ appid: 1001 })
      // if (!hasPre.data) return

      // const perFolderId = this.selectList[0]
      // const teamId = this.knowType == 'person' ? '' : local.get('teamMessage').id
      // const ownerType = this.knowType == 'person' ? 0 : local.get('teamMessage').ownerType
      // let route = router.resolve({ name: 'GenerateImage' }).href
      // route =
      //   route +
      //   `?caseId=${value.id}&folderId=${perFolderId}&teamId=${teamId}&ownerType=${ownerType}&scene=database`
      if (!value.knowledgeBasePromptInfo?.prompt?.length) {
        AModal.confirm({
          title: '温馨提示',
          zIndex: 9999,
          icon: h(ExclamationCircleFilled, {
            class: 'text-primary'
          }),
          content: '该作品没有提示词和任何参数，是否解析提示词生成同款。',
          centered: true,
          onOk() {
            databaseAnalyzePrompt({
              id: value.id
            }).then((res) => {
              if (res.data) {
                message.info('该案例没有提示词正在解析，请提示词解析完成后再点击生成同款。')
                eventsBus.emit('analyze', value.id)
              }
            })
          }
        })
        return
      }
      // window.open(route, '_blank')
      router.push({
        name: 'DesignAgent'
      })
      localCache.setCache('generateSame', value)
    },
    setCheckedNodes(state, value) {
      state.checkedNodes = value
    },
    setSelectList(state, value) {
      state.selectList = value
    },
    setUploadFile(state, value) {
      state.selectList = value
    }, // 保存到知识库
    openSaveToDatabaseModal(value = null) {
      this.saveToDatabaseVisible = true
      this.saveToDatabaseData = cloneDeep(value)
    },
    closeSaveToDatabaseModal() {
      this.saveToDatabaseVisible = false
      this.saveToDatabaseData = null
    },
    // 新建文件夹
    openNewFolderModal(value = null) {
      this.newFolderVisible = true
      this.newFolderData = cloneDeep(value)
    },
    //协作者
    openTeamWorkerModal(value = null) {
      this.teamWorkerModalVisible = true
      this.teamWorkerModalData = cloneDeep(value)
    },
    closeTeamWorkerModal() {
      this.teamWorkerModalVisible = false
      this.teamWorkerModalData = null
    },
    //顶部查询协作者
    async queryFolderCollaboratorsAction() {
      this.workerList = []
      if (runningEnvironment() !== 'person' && this.selectList[0] !== '0') {
        const res = await queryFolderCollaborators(
          {
            dirId: this.selectList[0],
            dirType: '1'
          },
          this.selectList[0]
        )
        this.workerList = res.data || []
      }
    },
    //查询权限列表
    async queryModulePermissionsAction() {
      const res = await queryModulePermissions({
        module: 'aiDam'
      })
      this.permissionList = res.data.map((i) => {
        return {
          label: i.name,
          value: i.code
        }
      })
    },
    closeNewFolderModal() {
      this.newFolderVisible = false
      this.newFolderData = null
    },
    // 文件夹排序
    openSortFolderModal(value = null) {
      this.sortFolderVisible = true
      this.sortFolderData = cloneDeep(value)
    },
    closeSortFolderModal() {
      this.sortFolderVisible = false
      this.sortFolderData = null
    },
    // 复制文件夹
    openCopyFolderModal(value = null) {
      this.copyFolderVisible = true
      this.copyFolderData = cloneDeep(value)
    },
    closeCopyFolderModal() {
      this.copyFolderVisible = false
      this.copyFolderData = null
    },
    // 移动到，复制到
    openMoveFolderModal(value = null) {
      this.moveFolderVisible = true
      this.moveFolderData = cloneDeep(value)
    },
    closeMoveFolderModal() {
      this.moveFolderVisible = false
      this.moveFolderData = null
    },
    // 删除文件夹
    openDeleteFolderModal(value = null) {
      this.deleteFolderVisible = true
      this.deleteFolderData = cloneDeep(value)
    },
    closeDeleteFolderModal() {
      this.deleteFolderVisible = false
      this.deleteFolderData = null
    },
    // 分享
    openShareFolderModal(value = null) {
      this.shareFolderVisible = true
      this.shareFolderData = cloneDeep(value)
    },
    closeShareFolderModal() {
      this.shareFolderVisible = false
      this.shareFolderData = null
    }
  }
})
